export const OldLoadsRoute = {
  path: '/loadboard/old',
  load: () => import('./OldLoads'),
  protected: true,
};
